/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetNewsItem200ResponseDataRelevantPostsInner
 */
export interface GetNewsItem200ResponseDataRelevantPostsInner {
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseDataRelevantPostsInner
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseDataRelevantPostsInner
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseDataRelevantPostsInner
   */
  category?: string | null
  /**
   *
   * @type {Date}
   * @memberof GetNewsItem200ResponseDataRelevantPostsInner
   */
  publishedAt?: Date | null
  /**
   *
   * @type {string}
   * @memberof GetNewsItem200ResponseDataRelevantPostsInner
   */
  readingTime?: string | null
}

/**
 * Check if a given object implements the GetNewsItem200ResponseDataRelevantPostsInner interface.
 */
export function instanceOfGetNewsItem200ResponseDataRelevantPostsInner(
  value: object
): value is GetNewsItem200ResponseDataRelevantPostsInner {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  return true
}

export function GetNewsItem200ResponseDataRelevantPostsInnerFromJSON(
  json: any
): GetNewsItem200ResponseDataRelevantPostsInner {
  return GetNewsItem200ResponseDataRelevantPostsInnerFromJSONTyped(json, false)
}

export function GetNewsItem200ResponseDataRelevantPostsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsItem200ResponseDataRelevantPostsInner {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    category: json['category'] == null ? undefined : json['category'],
    publishedAt:
      json['publishedAt'] == null ? undefined : new Date(json['publishedAt']),
    readingTime: json['readingTime'] == null ? undefined : json['readingTime'],
  }
}

export function GetNewsItem200ResponseDataRelevantPostsInnerToJSON(
  value?: GetNewsItem200ResponseDataRelevantPostsInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    category: value['category'],
    publishedAt:
      value['publishedAt'] == null
        ? undefined
        : (value['publishedAt'] as any).toISOString(),
    readingTime: value['readingTime'],
  }
}
